import { useRef } from 'react';

/*
  useDebouncedFn: Hook to provide a render-stable debounced version
  of the passed function

  Does not (yet) support "leading" debounce option

  Returns: debounced function
*/

export function useDebouncedFn<TArgs extends unknown[]>(
  fn: (...args: TArgs) => void,
  delay: number,
) {
  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const inner = (...args: TArgs) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => fn(...args), delay);
  };

  return inner;
}
